import React, { useState, useEffect, useRef } from "react";
import {Button, Table, Typography} from "antd";
import { TablePaginationConfig } from "antd/lib/table";
import type { TableProps } from "antd";
import SPTableActionBar from "../table-action-bar";
import EnumKeyToText from "components/product-price/base/EnumKeyToText";

import { useCSOrderListTemplate } from "hooks/notification/csOrderList";

import { DEFAULT_PAGE_INFO } from "consts";
import emiter, { _EVENTS } from "../../../../events";
import {useOrderList} from "hooks/order-management/order-list";

const { Text } = Typography

interface IComponentProps {
  enums?: any;
  permission?: any;
}
interface CSOrderListTemplateTableDataType {
  key?: any;
  id?: any;
  name?: any;
  state?: any;
  createDate?: any;
}
const SPTable: React.FC<IComponentProps> = (props) => {
  const { enums, permission } = props;

  const { tableActionView } = useOrderList();

  // todo：确定这块的字段名
  const columns: TableProps<CSOrderListTemplateTableDataType>["columns"] =
    [
      { title: "工单编号", width: 120, dataIndex: "case_id", key: "case_id" },
      {
        title: "工单标签",
        width: 150,
        dataIndex: "tags",
        key: "case_id",
        render: (_: any, record: any) => (record?.tags || []).map((tag: string) => <div>{tag}</div>)
      },
      // 打开订单详情抽屉调用它hooks里面的tableActionView方法即可
      { title: "订单编号", width: 220, key: "case_id", render: (_: any, record: any) => (

          <Text
            style={{color: 'var(--ant-primary-color)'}}
            onClick={() => tableActionView(record)}
            type="danger"
          >
            {record.order_code || "--"}
          </Text>
        ) },
      {
        title: "取车门店",
        width: 150,
        dataIndex: "pickup_store_name",
        key: "case_id",
      },
      { title: "还车门店", width: 150, dataIndex: "return_store_name", key: "case_id" },
      { title: "工单类型", width: 80, dataIndex: "case_title", key: "case_id" },
      {
        title: "工单状态",
        width: 100,
        dataIndex: "case_status",
        key: "case_id",
        render: (_, record) => (
          <EnumKeyToText data={record} enums={enums} valueKey={'case_status'} nameSpace={'case_status'} />
        ),
      },
      { title: "创建时间", width: 150, dataIndex: "create_time", key: "create_time" },
      {
        title: "操作",
        width: 150,
        key: "case_id",
        fixed: "right",
        render: (_, record) => (
          <SPTableActionBar permission={permission} data={record} />
        ),
      },
    ];

  const dataRef = useRef({});
  const [data, setData] = useState<any>([]);
  const [totalCount, setTotalCount] = useState<any>(0);
  const [currentPageData, setCurrentPageData] = useState<any>();
  const [loading, setLoading] = useState<any>(false);

  const { search, tablePagination } = useCSOrderListTemplate();

  const load = (params?: any) => {
    params = Object.assign(
      { ...DEFAULT_PAGE_INFO },
      { ...dataRef.current },
      params
    );
    setLoading(true);
    search(params)
      .then((data: any) => {
        dataRef.current = params;
        const res = data?.data;
        setData(res?.list || []);
        setTotalCount(res?.total);
        setCurrentPageData({
          page: res.page || 1,
          page_size: res.page_size || 10,
        });
      })
      .catch((err) => {
        console.error("csOrderList search error", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onPagination = (pagination: TablePaginationConfig) => {
    tablePagination(
      Object.assign(dataRef.current, {
        page: pagination.current,
        page_size: pagination.pageSize,
      })
    );
  };

  useEffect(() => {
    emiter.on(_EVENTS.NOTIFICATION.CS_ORDER_LIST.SEARCH, load);
    return () => {
      emiter.removeAllListeners(_EVENTS.NOTIFICATION.CS_ORDER_LIST.SEARCH);
    };
  }, []);

  return (
    <>
      <Table
        size="middle"
        columns={columns}
        dataSource={data}
        rowKey={(cols) => cols.id}
        scroll={{ x: "100%" }}
        loading={loading}
        pagination={{
          total: totalCount,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total) => `共 ${total} 条数据`,
          current: currentPageData?.page,
          pageSize: currentPageData?.page_size,
        }}
        onChange={onPagination}
      />
    </>
  );
};

export default SPTable;
